// extracted by mini-css-extract-plugin
export default {"container":"CopyableText-module__container___Krw6R","copyIcon":"CopyableText-module__copyIcon___wd0DM"};